import React from 'react';
import styled from '@emotion/styled';
import { Helmet } from 'react-helmet';

import imgMain from '../../assets/imgs/about/flavor/img-main.jpg';
import imgMainSp from '../../assets/imgs/about/flavor/sp/img-main.jpg';

import AboutMain from '../../components/organisms/aboutDetail/aboutDetailMain';
import SectionLineup from '../../components/organisms/sectionLineup';
import ArticleWrap from '../../components/organisms/articleWrap';
import ArticleBody from '../../components/organisms/articleBody';
import InnerLinkGroup from '../../components/molecules/about/innerLinkGroup';
import ArticleHeader from '../../components/molecules/articleHeader';
import ArticleSection from '../../components/molecules/articleSection';
import TextBlock from '../../components/molecules/textBlock';
import ArticleImage from '../../components/atoms/articleImage';
import Text from '../../components/atoms/text';
import Caption from '../../components/atoms/caption';

const Container = styled.div`
`;

const ColumnDetail = (props) => {
  return(
    <Container>
      <Helmet
          title="目指せ！お口クチュクチュを続けたくなる香味！モンダミン研究員のこだわりとは？ | モンダミン 公式サイト | アース製薬"
          meta={[
              { name: 'description', content: '洗口液は味や香りが苦手だと毎日使い続けるのはなかなか難しいもの。みんなに愛される香味を日々追求している研究員のこだわりをご紹介します。' },
              { name: 'keywords', content: 'モンダミン,もんだみん,mondahmin,オーラルケア,アース製薬' }
          ]}
        >
        <body data-block-header="true" />
      </Helmet>
      <AboutMain bg={imgMain} bgSp={imgMainSp}></AboutMain>
      <ArticleWrap>
        <ArticleBody>
          <ArticleHeader sub={<>目指せ！お口クチュクチュを続けたくなる香味！</>} title={<>モンダミン研究員のこだわりとは?</>}>
            洗口液は味や香りが苦手だと毎日使い続けるのはなかなか難しいもの。<br />みんなに愛される香味を日々追求している研究員のこだわりをご紹介します。
          </ArticleHeader>
          <ArticleSection heading={<>洗口液で香味は重要！</>}>
            <TextBlock>
              <Text>オーラルケアは口に入れるものだから、味や使用感が自分に合ったものでないと使うのをやめてしまったり、なかなか続かないもの。洗口液を使わなくなってしまった人の約5人に1人（17%）*は、「味や刺激が苦手だった」そうです。<br />香味が合わないことでオーラルケアを使わなくなってしまっては意味がない！でもモンダミンは発売当初から現在まで、毎日使い続けてもらえるような香味にこだわり続けています。そこで、今回は香味に関するこだわりポイントについてご紹介します。</Text>
              <Caption>＊アース製薬調べ。『洗口液に関するアンケート』に基づく。</Caption>
            </TextBlock>
          </ArticleSection>
          <ArticleSection heading={<>香味を決定するまでの<br />長き道のり</>}>
            <TextBlock>
              <ArticleImage filename={'about/flavor/img-01.jpg'}></ArticleImage>
              <Text>モンダミンには薬用成分や香料だけでなくお口を乾燥から守る濃グリセリン (湿潤剤)、味を整えるキシリトール(矯味剤)といったさまざまな成分が配合されています。<br />様々な成分があると、香味を悪くしてしまうものもあるのでは…と気になりますが、ここが研究員の腕の見せどころ！口臭予防や歯肉炎予防などの効果にこだわりつつ、可能な限り香味にマイナスの影響を与えにくい成分を選定して配合しています。<br />とはいえ商品設計上、どうしても味が悪くなる成分が必要なこともあります。その場合は配合量をできるだけ少なくし、さらに味付けを工夫して気分よく使い続けられる香味の洗口液になるように調整しています。<br />さらに、モンダミン研究員は他の研究員やターゲットの方に意見を聞きながら、何度も試作・改良を重ねてベストな香味と使用感に仕上げていきます。（多いときは1日20回くらい香味を試すことも！）そして最終段階では、大規模なモニターテストを実施して狙い通りの香味になっていることを第三者の目線でしっかり確認し、ついに香味・使用感が決定します。</Text>
            </TextBlock>
          </ArticleSection>
          <ArticleSection heading={<>アイテムに合わせた香味や<br className="pcOnly" />使用感で、1人1人が満足する<br className="pcOnly" />モンダミンを！</>}>
            <TextBlock>
              <ArticleImage filename={'about/flavor/img-02.png'}></ArticleImage>
              <Text>たくさんのラインナップが揃っているモンダミン。商品のコンセプトに合わせて香味や使用感も細かく調整されています。これも、それぞれのアイテムをおすすめしたい方により満足していただき、長く愛用してもらうためのこだわりです。<br />例えば高い洗浄力が特長の「モンダミン ペパーミント」は、効果をより実感してもらうため、高精製したペパーミントオイルを贅沢に配合し、すっきりと爽快感のある後味に仕上げています。発売から30年、処方を改良しても香味を損なわないようにこだわり続けています。<br />歯肉炎予防におすすめの「モンダミン メディカルクリア」は、歯ぐきにやさしい刺激を押さえた香味をセレクト。「モンダミン ナイトクリア」はおやすみ前にも使いやすいさっぱりとした香味に仕上げています。<br />お子さんが大好きないちご味・ぶどう味の「モンダミン Kid’s」は、開発当初「甘すぎるのでは」といった意見も…それでも「お子様が使いたくなる、使い続けられる香味」にこだわったことで、現在は多くのお子様にお使いいただいている人気アイテムです。（もちろん甘くてもむし歯予防効果はあるのでご安心を！）</Text>
            </TextBlock>
          </ArticleSection>
          <ArticleSection heading={<>オーラルケアを<br className="pcOnly" />毎日続けてもらうため、<br className="pcOnly" />これからも担当研究者の<br className="pcOnly" />開発は続く！</>}>
            <TextBlock>
              <Text>お口トラブルを防ぐために、口内を清潔に保つことは大事なポイント！そのためにオーラルケアは毎日続けることが重要です。<br />でも、ケア自体が楽しく気持ちよくなければ毎日は続けられませんよね。そこで、効果に合った香味と気持ちのいい使用感にこだわって、モンダミン研究員は日々処方開発を続けています。今日のお口クチュクチュのひとときは、モンダミン研究員になった気分で洗口液の味や香りを分析してみてはいかがでしょうか？</Text>
            </TextBlock>
          </ArticleSection>
        </ArticleBody>
        <InnerLinkGroup path={props.path}></InnerLinkGroup>
      </ArticleWrap>
      <SectionLineup></SectionLineup>
    </Container>
  );
};
export default ColumnDetail;
